import { Columns3 } from 'lucide-react'
import type { RefObject } from 'react'
import type { ColumnVisibilityDef } from '../hooks/useColumnVisibility'
import { Button } from './ui/button'

interface ColumnVisibilityToggleProps {
  title: string
  columns: ColumnVisibilityDef[]
  isOpen: boolean
  hiddenCount: number
  wrapperRef: RefObject<HTMLDivElement | null>
  isVisible: (id: string) => boolean
  onToggle: (id: string) => void
  onToggleOpen: () => void
}

export function ColumnVisibilityToggle({
  title,
  columns,
  isOpen,
  hiddenCount,
  wrapperRef,
  isVisible,
  onToggle,
  onToggleOpen,
}: ColumnVisibilityToggleProps) {
  return (
    <div className="relative" ref={wrapperRef}>
      <Button
        variant="outline"
        size="sm"
        onClick={onToggleOpen}
        aria-label={title}
        title={title}
        className="relative h-8 w-8 p-0"
      >
        <Columns3 className="h-4 w-4" aria-hidden="true" />
        {hiddenCount > 0 && (
          <span className="-top-1 -right-1 absolute rounded-full bg-blue-100 px-1.5 py-0.5 font-semibold text-blue-700 text-xs leading-none">
            {hiddenCount}
          </span>
        )}
      </Button>
      {isOpen && (
        <div className="absolute top-full left-0 z-50 mt-1 w-44 rounded-md border border-gray-200 bg-white py-1 shadow-lg">
          {columns.map((column) => (
            <label
              key={column.id}
              className="flex cursor-pointer items-center gap-2 px-3 py-1.5 text-sm hover:bg-gray-50"
            >
              <input
                type="checkbox"
                checked={isVisible(column.id)}
                disabled={column.alwaysVisible}
                onChange={() => onToggle(column.id)}
                className="h-3.5 w-3.5 rounded border-gray-300"
              />
              <span className={column.alwaysVisible ? 'opacity-60' : ''}>
                {column.label}
              </span>
            </label>
          ))}
        </div>
      )}
    </div>
  )
}
